import $ from "jquery";
import { Modal } from "bootstrap";

// Открытие модалки редактирования
if(location.href.includes("reviews/my") || location.href.includes("reviews/moderate")) {

const editModal = new Modal(document.getElementById("edit-review-modal"));
const deleteModal = new Modal(document.getElementById("delete-review-modal"));

$(document).on("click", ".btn-edit-review", function () {
  const reviewId = $(this).data("id");
  const description = $(this).data("description");

  $("#edit_review_id").val(reviewId);
  $("#edit_description").val(description);

  editModal.show();
});

// Отправка формы редактирования
$("#edit-review-form").on("submit", function (e) {
  e.preventDefault();

  const reviewId = $("#edit_review_id").val();
  const formData = new FormData(this);

  $.ajax({
    url: "/review",
    type: "PATCH",
    data: formData,
    processData: false,
    contentType: false,
    success: function () {
      location.reload();
    },
    error: function (xhr) {
      console.log("Ошибка при редактировании: " + xhr.responseText);
    },
    complete: function (data) {
      editModal.hide();
    },
  });
});

// Открытие модалки удаления
$(document).on("click", ".btn-delete-review", function () {
  const reviewId = $(this).data("id");
  $("#delete_review_id").val(reviewId);
  deleteModal.show();
});

// Отправка формы удаления
$(".review-delete-button").on("click", function (e) {
  const reviewId = $("#delete_review_id").val()
  e.preventDefault();

  const formData = $("#delete-review-form").serialize();

  $.ajax({
    url: `/review/${reviewId}`,
    type: "POST",
    data: formData,
    success: function () {
      // location.reload();
    },
    error: function (xhr) {
      console.log("Ошибка при удалении: " + xhr.responseText);
    },
    complete: function (data) {
      deleteModal.hide()
      location.reload();
    },
  });
});

}
